import React, { useEffect } from 'react';
import i18n from '../../../../../../utils/ChrI18n';

const GuestListUpdate = props => {
  useEffect(() => {
    EventsConfig.initializeInviteeChangeForm(
      props.id, props.updateGuestList.confirmationMessage
    );
  }, []);

  return(
    <div className='mt-3'>
      <div className="cui-border-radius-6 cui-warning-mild p-xs">
        <div className="media-left p-r-0 align-middle">
          <span className="fa-stack fa-lg fa-fw m-r-xs small cui-text-warning">
            <i className="fa-solid fa-circle fa-stack-2x" />
            <span className="fa-regular fa-envelope fa-stack-1x fa-inverse" />
          </span>
          </div>
          <div className="media-body align-middle">
            <span className="font-500">
              { i18n.t('feature.program_event.content.admin_view_changed_text_v2') }
            </span>
            <a className="ml-2 font-bold underline" id={`cjs-invitess-change-event-${props.id}-link`} data-url={ props.updateGuestList.url } href="#">
              { i18n.t('feature.program_event.content.update_guest_list') }
            </a>
          </div>
      </div>
    </div>
  )
};

export default GuestListUpdate;